import Item from "./radio-group-item.svelte"
import Root from "./radio-group.svelte"

export {
  Root,
  Item,
  //
  Root as RadioGroup,
  Item as RadioGroupItem,
}
